var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap-avatar"},[(_vm.src)?_c('van-image',{attrs:{"src":_vm.src,"fit":"cover"}}):_c('van-icon',{staticClass:"base-avatar",attrs:{"name":"manager","color":"#AEAEAE","size":_vm.size}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }